<template>
  <div :class="classes()">
    <template v-if="labelOnSamePosition">
      <div :class="`${el}__inner`">
        <div :class="`${el}__form`" @click="click" aria-hidden="true">
          <span :class="`${el}__control`" />
        </div>
      </div>
      <div :class="`${el}__copy ${el}__copy--bold`">
        {{ checked ? activeLabel : inactiveLabel }}
      </div>
    </template>
    <template v-else>
      <div
        :class="{
          [`${el}__copy`]: true,
          [`${el}__copy--bold`]: !checked,
        }"
      >
        {{ inactiveLabel }}
      </div>
      <div :class="`${el}__inner`">
        <div :class="`${el}__form`" @click="click" aria-hidden="true">
          <span :class="`${el}__control`" />
        </div>
      </div>
      <div
        :class="{
          [`${el}__copy`]: true,
          [`${el}__copy--bold`]: checked,
        }"
      >
        {{ activeLabel }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    inactiveLabel: {
      type: String,
      required: true,
    },
    activeLabel: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    labelOnSamePosition: {
      type: Boolean,
    },
  },
  data() {
    return {
      el: 'o-toggleSwitch',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          'is-active': this.checked,
          [`${el}--labelOnSamePosition`]: this.labelOnSamePosition,
          [`${el}--disabled`]: this.disabled,
        };
      },
    };
  },
  methods: {
    click() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>
